

































































import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import SectionWrappe from "@/components/section/SectionWrappe.vue";
import Button from "@/components/button/Button.vue";
import * as types from "@/store/constants/types";
import Http from "@/api/http/fetch/index";
import { makeId } from "@/utils/objectId";
import { getFormatDate } from "@/utils/global";
import { sendEvent } from "@/utils/analytics";
import RateUsItem from "./reteUs/RateUsItem.vue";
import { isIos } from "@/utils/lodash";

@Component({
  components: {
    SectionWrappe,
    Button,
    CheckInItem: () => import("./dailyCheckIn/CheckInItem.vue"),
    RateUsItem
  }
})
export default class DailyChallenge extends Vue {
  @Getter(types.GETTER_SETTING_DATA)
  private settingData: any;
  @Action(types.CHECK_GX_USER_LOGINED)
  private checkSignGxUser: any;
  @Getter(types.GETTER_MASTER_ID)
  private masterId: any;
  @Action(types.REQUEST_ADMOB_AVAILABLE)
  private requestAdmobAvailable: any;
  @Action(types.WATCH_VIDEO)
  private watchVideo: any;

  private videoName = "free_coins";
  private admob_enabled: boolean = false;
  private hasRequst: boolean = false;

  private async clickWatchVideo() {

    if (!this.hasRequst) {
      this.admob_enabled = await this.requestAdmobAvailable();
      this.hasRequst = true;
    }

    this.watchVideo({videoName: this.videoName, admob_enabled: this.admob_enabled, reward: true})
  }

    get isShowRateUs() {
    return this.settingData && this.settingData.rate_task && this.settingData.rate_task.reward && this.settingData.rate_task.status !== 0 ;
  }

  get watchVideoReward() {
    return this.settingData.rewards.video;
  }

  get is_first_priority() {
    const { rate_task } = this.settingData;
    return rate_task ? rate_task.is_first_priority : false;
  }
}
